import { http } from '@/services/http'

/* eslint-disable camelcase */

export default {
  create({ text, value, type_id, country_id }) {
    return http.post('/attributes/option', { text, value, type_id, country_id })
  },
  delete({ id }) {
    return http.delete(`/attributes/option/${id}`)
  },
  getList({ type }) {
    return http.get(`/attributes/option?type=${type}`)
  },
  getOne({ id }) {
    return http.get(`/attributes/option/${id}`)
  },
  getTypes() {
    return http.get('/attributes/option/types')
  },
  update({ text, value, type_id, id, country_id }) {
    return http.put(`/attributes/option/${id}`, {
      text,
      value,
      type_id,
      country_id
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/attributes-options.js